import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: { borrowerGrossRevenueLatest },
} = loanFormModel;

export class BorrowerGrossRevenueLatestValidation implements ValidationSchema {
  public name: string = borrowerGrossRevenueLatest.name;
  public label: string = borrowerGrossRevenueLatest.label;
  public dependsOn: string[] = [];
  public type = 'number';
  public required = {
    message: 'This field is required',
    value: true,
  };
  public nullable = true;
}
export default new Validation(new BorrowerGrossRevenueLatestValidation());
